import { useContext, useDebugValue } from "react";
import SensorContext from "../context/SensorProvider";

const useSensorDetails = () => {
    const { sensorDetails } = useContext(SensorContext);
    useDebugValue(sensorDetails, sensorDetails => sensorDetails?.nodeID ? "Sensor Selected" : "Sensor Not Selected")
    return useContext(SensorContext);
}

export default useSensorDetails;